import React from "react";
import { cn } from "../lib/utils";

// Annual billing = pay for 10 months (2 months free).
export const ANNUAL_MONTHS_BILLED = 10;

export function annualAmount(monthlyAmount) {
  return monthlyAmount * ANNUAL_MONTHS_BILLED;
}

export function BillingCycleToggle({ value, onChange, className = "" }) {
  return (
    <div
      className={cn("inline-flex items-center rounded-full border border-border bg-surface p-0.5", className)}
      data-testid="billing-cycle-toggle"
    >
      <button
        type="button"
        onClick={() => onChange("monthly")}
        data-testid="billing-monthly"
        className={cn(
          "px-3.5 py-1 rounded-full text-xs font-medium transition-colors",
          value === "monthly" ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:text-foreground"
        )}
      >
        Monthly
      </button>
      <button
        type="button"
        onClick={() => onChange("annual")}
        data-testid="billing-annual"
        className={cn(
          "px-3.5 py-1 rounded-full text-xs font-medium transition-colors flex items-center gap-1.5",
          value === "annual" ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:text-foreground"
        )}
      >
        Annual
        <span
          className={cn(
            "text-[10px] font-semibold rounded-full px-1.5 py-px",
            value === "annual" ? "bg-black/15 text-black" : "bg-accent/15 text-accent"
          )}
        >
          2 months free
        </span>
      </button>
    </div>
  );
}
